export const loaderConstants = {
  LOADER_START: 'LOADER_START',
  LOADER_STOP: 'LOADER_STOP',
};
